<template>
  <div class="accordion" id="my-accordion" role="tablist">
    <div class="card mb-1">
      <div class="card-header p-1" role="tab">
        <button
          class="btn btn-info w-100 text-start"
          type="button"
          :aria-expanded="isOpen(1)"
          :aria-controls="'accordion-1'"
          @click="toggle(1)"
        >
          Open
        </button>
      </div>
      <div
        :id="'accordion-1'"
        class="collapse"
        :class="{ show: isOpen(1) }"
        role="tabpanel"
        :data-bs-parent="'#my-accordion'"
      >
        <div class="card-body">
          <p class="card-text">I start opened because <code>visible</code> is <code>true</code></p>
          <p class="card-text">{{ text }}</p>
        </div>
      </div>
    </div>

    <div class="card mb-1">
      <div class="card-header p-1" role="tab">
        <button
          class="btn btn-info w-100 text-start"
          type="button"
          :aria-expanded="isOpen(2)"
          :aria-controls="'accordion-2'"
          @click="toggle(2)"
        >
          Closed
        </button>
      </div>
      <div
        :id="'accordion-2'"
        class="collapse"
        :class="{ show: isOpen(2) }"
        role="tabpanel"
        :data-bs-parent="'#my-accordion'"
      >
        <div class="card-body">
          <p class="card-text">{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  data () {
    return {
      openPanel: 1,
      text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
    }
  },
  methods: {
    toggle (panel) {
      this.openPanel = this.openPanel === panel ? null : panel
    },
    isOpen (panel) {
      return this.openPanel === panel
    }
  }
}
</script>
